import WarningIcon from "@mui/icons-material/Warning";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

const oldDeadlinesData = [
	{
		type: "Action Required",
		tab: "business",
		color: "#f8d7da",
		fontColor: "#FF0000",
		Icon: <WarningIcon sx={{ color: "#FF0000" }} />,
		data: [
			{
				item: "Year End Accounts",
				madeUpToDate: "31st December 2024",
				dueDate: "31st September 2024",
				action: "Speak to Accountant",
			},
		],
	},
	{
		type: "Future Deadlines",
		tab: "business",
		color: "#d4edda",
		fontColor: "#09bd09",
		Icon: <CalendarTodayIcon style={{ color: "#09bd09" }} />,
		data: [],
		// data: [
		// 	{
		// 		item: "Confirmation Statement",
		// 		madeUpToDate: "20th July 2025",
		// 		dueDate: "3rd August 2025",
		// 		action: "No Action required",
		// 	},
		// ],
	},
	{
		type: "Personal Deadlines",
		tab: "personal",
		color: "#cce5ff",
		fontColor: "#0022ff",
		Icon: <CalendarTodayIcon style={{ color: "#0022ff" }} />,
		// data: [
		// 	{
		// 		item: "Car Insurance Renewal",
		// 		madeUpToDate: "10th May 2025",
		// 		dueDate: "15th May 2025",
		// 		action: "Compare quotes and renew",
		// 	},
		// 	{
		// 		item: "Gym Membership Renewal",
		// 		madeUpToDate: "1st July 2025",
		// 		dueDate: "10th July 2025",
		// 		action: "Decide on renewal",
		// 	},
		// 	{
		// 		item: "Passport Expiry",
		// 		madeUpToDate: "12th December 2025",
		// 		dueDate: "1st November 2025",
		// 		action: "Apply for renewal",
		// 	},
		// ],
		data: [],
	},
];

const deadlinesData = [
	{
		type: "Action Required",
		tab: "business",
		color: "#f8d7da",
		fontColor: "#FF0000",
		Icon: <WarningIcon sx={{ color: "#FF0000" }} />,
		data: [
			{
				item: "Year End Accounts",
				madeUpToDate: "31st December 2024",
				dueDate: "31st September 2024",
				action: "Speak to Accountant",
			},
		],
	},
	{
		type: "Future Deadlines",
		tab: "business",
		color: "#d4edda",
		fontColor: "#09bd09",
		Icon: <CalendarTodayIcon style={{ color: "#09bd09" }} />,
		data: [],
	},
	{
		type: "Personal Deadlines",
		tab: "personal",
		color: "#cce5ff",
		fontColor: "#0022ff",
		Icon: <CalendarTodayIcon style={{ color: "#0022ff" }} />,
		data: [],
	},
];

export { oldDeadlinesData, deadlinesData };
